exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style-module__title___2Hntz{padding-left:0.65em;font-size:1.5em !important}.style-module__text___176ag{padding-left:1.065em;color:#3B436C}.style-module__button___ZTXFn{justify-content:flex-end}.style-module__loading___2dI3M{display:flex;align-items:center;justify-content:flex-end}.style-module__loading__circle___1I6Y8{stroke-width:2}.style-module__loading___2dI3M.style-module__loading_primary___ufXC3{color:#6D1CF0}\n", ""]);

// exports
exports.locals = {
	"title": "style-module__title___2Hntz",
	"text": "style-module__text___176ag",
	"button": "style-module__button___ZTXFn",
	"loading": "style-module__loading___2dI3M",
	"loading__circle": "style-module__loading__circle___1I6Y8",
	"loading_primary": "style-module__loading_primary___ufXC3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/ShareWithTeacherModal/style.module.scss
// module id = 1900
// module chunks = 0